import React, { useState, useEffect, useRef } from 'react';

interface LightbulbProps {
  mousePosition: { x: number; y: number };
}

const Lightbulb: React.FC<LightbulbProps> = ({ mousePosition }) => {
  const [brightness, setBrightness] = useState(1);
  const bulbRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (bulbRef.current) {
      const bulbRect = bulbRef.current.getBoundingClientRect();
      const bulbCenter = {
        x: bulbRect.left + bulbRect.width / 2 + window.scrollX,
        y: bulbRect.top + bulbRect.height / 2 + window.scrollY,
      };

      const distance = Math.hypot(
        mousePosition.x - bulbCenter.x,
        mousePosition.y - bulbCenter.y
      );

      const maxDistance = 500;
      const distanceRatio = Math.min(distance / maxDistance, 1);

      const minBrightness = 0.5;
      const maxBrightness = 3;

      const newBrightness =
        maxBrightness - distanceRatio * (maxBrightness - minBrightness);

      setBrightness(newBrightness);
    }
  }, [mousePosition]);

  return (
    <div className="lightbulb-container">
      <img
        ref={bulbRef}
        src="/lightbulb.png"
        alt="Lightbulb"
        className="lightbulb"
        style={{
          width: '200px',
          height: '300px',
          filter: `brightness(${brightness}) drop-shadow(0px 0px ${20 * (brightness - 0.5)}px rgba(255, 223, 0, ${brightness - 0.5}))`,
        }}
      />
    </div>
  );
};

export default Lightbulb;
